"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventLoadedSideEffect = eventLoadedSideEffect;
exports.eventLoadedSideEffectV2 = eventLoadedSideEffectV2;
exports.eventLoadedSideEffectV3 = eventLoadedSideEffectV3;
exports.computeEventProbabilitiesByMarketSaga = computeEventProbabilitiesByMarketSaga;
exports.fetchEventWithoutSideEffectsSaga = fetchEventWithoutSideEffectsSaga;
exports.fetchEventInitiallySaga = fetchEventInitiallySaga;
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const effects_1 = require("redux-saga/effects");
const isEmpty_1 = __importDefault(require("../../../utils/functions/isEmpty"));
const selectors_1 = require("../../CommonDataProvider/selectors");
const types_1 = require("../../ConfigProvider/types");
const selectors_2 = require("../../ConfigProvider/selectors");
const saga_1 = require("../../ConfigProvider/saga");
const selectors_3 = require("../../PlayersProvider/selectors");
const events_1 = require("../../../utils/events");
const computeEventProbabilitiesByMarket_1 = require("../../../utils/outcomes/computeEventProbabilitiesByMarket");
const computeOutcomes_1 = require("../../../utils/outcomes/computeEventProbabilitiesByMarket/v3/computeOutcomes");
const selectors_4 = require("../../LanguagesProvider/selectors");
const errors_1 = require("../../../utils/errors");
const findProbabilitiesWithPlayerIdParameter_1 = require("../../../utils/outcomes/findProbabilitiesWithPlayerIdParameter");
const api_1 = require("../../../api/events/api");
const selectors_5 = require("../selectors");
const slice_1 = require("../slice");
const utils_1 = require("../utils");
const fetchPlayersSaga_1 = require("./fetchPlayersSaga");
function* eventLoadedSideEffect(newEvent) {
    const prevEvent = yield (0, effects_1.select)((s) => (0, selectors_5.selectEventById)(s, newEvent.id));
    /* Check if event was changed */
    const eventChanged = !prevEvent || !(0, react_fast_compare_1.default)(prevEvent, newEvent);
    if (eventChanged) {
        yield (0, effects_1.put)(slice_1.eventsProviderActions.eventUpdated({ resData: newEvent }));
    }
    const playersChanged = yield (0, effects_1.call)(fetchPlayersSaga_1.fetchAndCheckIfPlayersChanged, prevEvent, newEvent);
    /* Check if probabilitires were not set before, selectMarketCategoriesInfosByEvent returns empty array */
    const currentEventProbabilities = yield (0, effects_1.select)((s) => (0, selectors_5.selectMarketCategoriesInfosByEvent)(s, newEvent.id));
    const needRecompute = eventChanged || playersChanged || (0, isEmpty_1.default)(currentEventProbabilities);
    if (needRecompute) {
        yield (0, effects_1.call)(computeEventProbabilitiesByMarketSaga, newEvent);
    }
}
function* eventLoadedSideEffectV2(newEvent) {
    const prevEvent = yield (0, effects_1.select)((s) => (0, selectors_5.selectEventById)(s, newEvent.id));
    const eventChanged = !prevEvent || !(0, utils_1.isEqualEventWithoutProbs)(prevEvent, newEvent);
    if (eventChanged) {
        yield (0, effects_1.put)(slice_1.eventsProviderActions.eventUpdated({ resData: Object.freeze(newEvent) }));
    }
    try {
        // By contract probs are required, but they actually can be null
        if (!newEvent.probabilities) {
            return;
        }
        const lastProbabilitiesVersion = yield (0, effects_1.select)((s) => (0, selectors_5.selectLastProbabilitiesVersion)(s, newEvent.id));
        const probsChanged = !prevEvent || lastProbabilitiesVersion !== newEvent.probabilities.version;
        const playersChanged = yield (0, effects_1.call)(fetchPlayersSaga_1.fetchAndCheckIfPlayersChanged, prevEvent, newEvent);
        /* Check if probabilitires were not set before, selectMarketCategoriesInfosByEvent returns empty array */
        const currentEventProbabilities = yield (0, effects_1.select)((s) => (0, selectors_5.selectMarketCategoriesInfosByEvent)(s, newEvent.id));
        const needRecompute = probsChanged || playersChanged || (0, isEmpty_1.default)(currentEventProbabilities);
        if (needRecompute) {
            yield (0, effects_1.call)(computeEventProbabilitiesByMarketSaga, newEvent);
            yield (0, effects_1.put)(slice_1.eventsProviderActions.updateProbabilitiesVersion({
                eventId: newEvent.id,
                version: newEvent.probabilities.version,
            }));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Could not handle event probabilities changes');
        console.error(error);
    }
}
function* eventLoadedSideEffectV3(newEvent) {
    var _a, _b;
    const prevEvent = yield (0, effects_1.select)((s) => (0, selectors_5.selectEventById)(s, newEvent.id));
    const eventChanged = !prevEvent ||
        !(0, utils_1.isEqualEventWithoutProbs)(prevEvent, newEvent) ||
        ((_a = prevEvent.probabilities) === null || _a === void 0 ? void 0 : _a.version) !== ((_b = newEvent.probabilities) === null || _b === void 0 ? void 0 : _b.version); // For cases when regions track hot probs from event
    if (eventChanged) {
        yield (0, effects_1.put)(slice_1.eventsProviderActions.eventUpdated({ resData: Object.freeze(newEvent) }));
    }
    try {
        if ((0, utils_1.needToClearOutcomes)(newEvent)) {
            yield (0, effects_1.put)(slice_1.eventsProviderActions.clearOutcomes({ eventId: newEvent.id }));
            return;
        }
        const lastProbabilitiesVersion = yield (0, effects_1.select)((s) => (0, selectors_5.selectLastProbabilitiesVersion)(s, newEvent.id));
        const probsChanged = !prevEvent || lastProbabilitiesVersion !== newEvent.probabilities.version;
        const playersChanged = yield (0, effects_1.call)(fetchPlayersSaga_1.fetchAndCheckIfPlayersChanged, prevEvent, newEvent);
        const newOutcomesStructEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_OUTCOMES_STRUCT_ENABLED);
        const isNotCalculatedBefore = yield (0, effects_1.select)((s) => {
            if (newOutcomesStructEnabled) {
                return (0, selectors_5.selectOutcomes)(s, newEvent.id) === selectors_5.EMPTY_OUTCOMES;
            }
            else {
                return (0, isEmpty_1.default)((0, selectors_5.selectVirtualCategoriesInfosByEvent)(s, newEvent.id));
            }
        });
        const needRecompute = probsChanged || playersChanged || isNotCalculatedBefore;
        if (needRecompute) {
            yield (0, effects_1.call)(computeEventProbabilitiesByMarketSaga, newEvent, playersChanged);
            yield (0, effects_1.put)(slice_1.eventsProviderActions.updateProbabilitiesVersion({
                eventId: newEvent.id,
                version: newEvent.probabilities.version,
            }));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Could not handle event probabilities changes');
        console.error(error);
    }
}
function* computeEventProbabilitiesByMarketSaga(event, forcePlayersUpdate = false) {
    const newOutcomesEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_OUTCOMES_ENABLED);
    const newOutcomesStructEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_OUTCOMES_STRUCT_ENABLED);
    const isNewSbCompetitorsNameEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_SB_COMPETITORS_NAME_ENABLED);
    const renameDate = yield (0, effects_1.select)(selectors_2.selectCompetitorsRenameDate);
    // У события в статусах EVENT_STATUSES_TO_CLEAR_OUTCOMES не может быть пробсов
    if ((0, utils_1.needToClearOutcomes)(event)) {
        yield (0, effects_1.put)(slice_1.eventsProviderActions.clearEventProbabilitiesByMarket({
            eventId: event.id,
        }));
        if (newOutcomesStructEnabled) {
            yield (0, effects_1.put)(slice_1.eventsProviderActions.clearOutcomes({ eventId: event.id }));
        }
        return;
    }
    const { sportId } = event.tournament;
    const config = yield (0, effects_1.select)(selectors_2.selectConfig);
    const marketsMap = yield (0, effects_1.select)(selectors_1.selectMarkets);
    const playersMap = yield (0, effects_1.select)(selectors_3.selectPlayers);
    const eventCompetitors = (0, events_1.getHomeAwayCompetitorsRenamed)({
        event,
        renameDate,
        isNewSbCompetitorsNameEnabled,
    });
    if (newOutcomesStructEnabled) {
        const probsWithPlayerIdParam = (0, findProbabilitiesWithPlayerIdParameter_1.findProbabilitiesWithPlayerIdParameter)(event.probabilities);
        const vCategoriesInfo = yield (0, effects_1.select)(selectors_1.selectVirtualCategoriesInfo);
        const vCategoriesSortedIds = yield (0, effects_1.select)(selectors_1.selectVirtualCategoriesSortedIds);
        const vMarketsInfo = yield (0, effects_1.select)(selectors_1.selectVirtualMarketsInfo);
        const prevOutcomes = yield (0, effects_1.select)((s) => { var _a; return (_a = (0, selectors_5.selectOutcomes)(s, event.id)) !== null && _a !== void 0 ? _a : { categories: {}, markets: {} }; });
        const outcomesDiff = (0, computeOutcomes_1.computeOutcomesDiff)({
            sportId,
            eventCompetitors,
            eventMarkets: event.probabilities.markets,
            eventStatus: event.status,
            vCategoriesInfo,
            vCategoriesSortedIds,
            vMarketsInfo,
            playersMap,
            marketsMap,
            probsWithPlayerIdParam,
            prevOutcomes,
            clientType: config.CLIENT_TYPE,
            forcePlayersUpdate,
        });
        if (outcomesDiff) {
            yield (0, effects_1.put)(slice_1.eventsProviderActions.outcomesChanged({
                eventId: event.id,
                outcomesDiff,
            }));
        }
        return;
    }
    if (newOutcomesEnabled) {
        const virtualCategories = yield (0, effects_1.select)(selectors_1.selectVirtualCategories);
        const virtualMarketInfosMap = yield (0, effects_1.select)(selectors_1.selectVirtualMarketInfosMap);
        const eventProbabilitiesByVirtualMarket = yield (0, effects_1.select)((state) => (0, selectors_5.selectEventProbabilitiesByVirtualMarketByEvent)(state, event.id));
        const virtualCategoriesInfosByEvent = yield (0, effects_1.select)((state) => (0, selectors_5.selectVirtualCategoriesInfosByEvent)(state, event.id));
        const diff = (0, computeEventProbabilitiesByMarket_1.computeEventProbabilitiesByMarketV3)({
            eventId: event.id,
            sportId,
            eventStatus: event.status,
            eventMarkets: event.probabilities.markets,
            eventCompetitors,
            // common data
            virtualCategories,
            virtualMarketInfosMap,
            marketsMap,
            // event outcomes cache
            eventProbabilitiesByVirtualMarket,
            virtualCategoriesInfos: virtualCategoriesInfosByEvent,
            playersMap,
            clientType: config.CLIENT_TYPE,
        });
        yield (0, effects_1.put)(slice_1.eventsProviderActions.computeEventProbabilitiesByMarketV3({
            eventId: event.id,
            ...diff,
        }));
        return;
    }
    const marketCategoriesMap = yield (0, effects_1.select)(selectors_1.selectMarketCategoriesMap);
    const categoryMarketInfosMap = yield (0, effects_1.select)(selectors_1.selectCategoryMarketInfosMap);
    const isComputeProbsOptimizationEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.COMPUTE_PROBS_OPTIMIZATION);
    if (isComputeProbsOptimizationEnabled) {
        const eventProbabilitiesByMarket = yield (0, effects_1.select)(selectors_5.selecteventProbabilitiesByMarket);
        const marketCategoriesInfosByEvent = yield (0, effects_1.select)(selectors_5.selectmarketCategoriesInfosByEvent);
        const diff = (0, computeEventProbabilitiesByMarket_1.computeEventProbabilitiesByMarketV2)({
            eventId: event.id,
            sportId,
            eventStatus: event.status,
            marketCategoriesMap,
            marketsMap,
            playersMap,
            categoryMarketInfosMap,
            eventCompetitors,
            eventMarkets: utils_1.EVENT_STATUSES_TO_CLEAR_OUTCOMES.includes(event.status)
                ? []
                : event.probabilities.markets,
            eventProbabilitiesByMarket: eventProbabilitiesByMarket[event.id],
            marketCategoriesInfos: marketCategoriesInfosByEvent[event.id],
            clientType: config.CLIENT_TYPE,
        });
        yield (0, effects_1.put)(slice_1.eventsProviderActions.computeEventProbabilitiesByMarketV2({
            eventId: event.id,
            ...diff,
        }));
    }
    else {
        yield (0, effects_1.put)(slice_1.eventsProviderActions.computeEventProbabilitiesByMarket({
            sportId,
            marketCategoriesMap,
            marketsMap,
            playersMap,
            categoryMarketInfosMap,
            eventCompetitors,
            eventProbabilities: event.probabilities,
            eventStatus: event.status,
            clientType: config.CLIENT_TYPE,
        }));
    }
}
function* fetchEventWithoutSideEffectsSaga({ reqData, }) {
    try {
        const currentLangCode = yield (0, effects_1.select)(selectors_4.selectCurrentLangCode);
        const reqPayload = { locale: currentLangCode };
        const { data: resData } = yield (0, effects_1.call)(api_1.getEvent, {
            ...reqData,
            ...reqPayload,
        });
        yield (0, effects_1.call)(eventLoadedSideEffect, resData);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventSuccess({ resData }));
    }
    catch (e) {
        const { eventId } = reqData;
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching event', error);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventError({ error, eventId }));
    }
}
function* fetchEventInitiallySaga(eventId) {
    try {
        const existingEvent = yield (0, effects_1.select)((state) => (0, selectors_5.selectEventById)(state, eventId));
        if (!existingEvent) {
            yield (0, effects_1.call)(fetchEventWithoutSideEffectsSaga, {
                reqData: { eventId },
            });
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('fetchEventInitiallySaga error', error);
    }
}
//# sourceMappingURL=eventProcessingSaga.js.map